module.exports = __webpack_public_path__ + "dist/img/namesInvoice.58b5bfc0.png";